import { createBrowserHistory, createMemoryHistory } from 'history';

const history = typeof document !== 'undefined' ? createBrowserHistory() : createMemoryHistory();
export default history;
